import AddNew from "./AddNew";
import List from "./List";

export default function Admins() {
    return (
        <>
            <AddNew/>
            <List/>
        </>
    )
}
